import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.css']
})
export class SkeletonLoaderComponent implements OnInit {

  @Input('count') count: number=1 ;
  @Input('theme') theme: any ;
  @Input('appearance') appearance: string;
  
  constructor() { }

  ngOnInit() {
  }

}
